module.exports = __webpack_public_path__ + "static/media/IRL.81c60325.svg";